import { dayjs } from 'utils/dayjs';

import { Distribution, DistributionGroup, DistributionStudent } from './Distribution';
import {
  DistributionResponseDTO,
  DistributionRequestDTO,
  DistributionGroupRequestDTO,
  DistributionStudentRequestDTO,
} from './api';

export const buildDistribution = (
  groupsDTO: DistributionResponseDTO,
  id: number
  ) => new Distribution({
    id,
    startDate: groupsDTO.startDate,
    endDate: groupsDTO.endDate,
    groups: groupsDTO.groups,
    referralLink: groupsDTO.referralLink
  });

const buildAssignedStudentsRequestDTO = (student: DistributionStudent): DistributionStudentRequestDTO => ({
  studentId: student.id,
  startDate: student.endDate && dayjs().format('YYYY-MM-DD'),
  endDate: student.endDate && dayjs(student.endDate).format('YYYY-MM-DD')
});

const buildAssignedGroupsRequestDTO = (
  group: DistributionGroup,
  defaultStartDate: string,
  defaultEndDate: string
  ): DistributionGroupRequestDTO => {
  const filteredStudents = group.assignedStudents.filter(student => student.isSelected);

  return ({
    groupId: group.id,
    startDate: group.endDate ? dayjs().format('YYYY-MM-DD') : defaultStartDate,
    endDate: group.endDate ? dayjs(group.endDate).format('YYYY-MM-DD') : defaultEndDate,
    assignedStudents: filteredStudents.map(buildAssignedStudentsRequestDTO)
  });
};

export const buildDistributionRequestDTO = (distribution: Distribution): DistributionRequestDTO => {
  const filteredGroups = distribution.groups.filter(group => group.isSelected);

  const defaultStartDate = dayjs(distribution.startDate).format('YYYY-MM-DD');
  const defaultEndDate = dayjs(distribution.endDate).format('YYYY-MM-DD');

  return ({
    assignedGroups: filteredGroups.map(group => buildAssignedGroupsRequestDTO(group, defaultStartDate, defaultEndDate)),
  });
};
